import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { GET_AD_CREATIVES_WITH_ASSETS } from '@/graphql/ad-creatives-library-queries'
import { AdCreativeWizard } from '@/components/mediaBuying/adCreatives/AdCreativeWizard'
import { CubeLoader } from '@/components/ui/cube-loader'

const CloneCreative = () => {
    const { id: campaignId, creativeId } = useParams()

    const { data, loading, error } = useQuery(GET_AD_CREATIVES_WITH_ASSETS, {
        variables: { campaignId },
        fetchPolicy: 'network-only',
    })

    if (loading) {
        return (
            <div className="tw:w-full tw:h-full tw:flex tw:items-center tw:justify-center" style={{ minHeight: 'calc(100vh - 50px)' }}>
                <CubeLoader size="default" fullScreen={true} />
            </div>
        )
    }

    const creatives = data?.AdCreative?.searchFilterAdCreativesJoinAssets || []
    const creative = creatives.find((c) => c.id === creativeId)

    if (error || !creative) {
        return (
            <div className="tw:w-full tw:h-full tw:flex tw:items-center tw:justify-center tw:text-white" style={{ minHeight: 'calc(100vh - 50px)' }}>
                <p>{error ? 'Failed to load creative.' : 'Creative not found.'}</p>
            </div>
        )
    }

    return <AdCreativeWizard cloneCreativeData={creative} />
}

export default CloneCreative
